<div
    #sideMenu
    class="main-menu"
    id="sideMenu"
    [class.main-menu-open]="isMenuOpen"
    [class.fixed]="appService.settings?.is_fixed_sidenav"
    (mouseenter)="!this.appService.settings?.is_fixed_sidenav ? menuEvent($event, true) : null"
    (mouseleave)="!this.appService.settings?.is_fixed_sidenav ? menuEvent($event, false) : null"
    ngClass.gt-sm="main-menu-big"
    ngClass.gt-lg="main-menu-big"
    ngClass.sm="main-menu-small"
    ngClass.xs="main-menu-small"
>
    <div class="main-menu-content flex flex-col" [ngStyle.lt-md]="{ 'margin-top': '61px' }">
        <div
            class="user-info flex items-center gap-2 cursor-pointer h-16 mx-2 my-1"
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menuUser"
            [matTooltip]="appService.language_dictionary.system_user"
        >
            <img
                *ngIf="this.appService.userData?.photo; else templateInitial"
                class="flex-none w-8 h-8 rounded-full border-2 border-solid border-outline"
                [src]="this.appService.serverUrl + '/public/uploads/user_photos/' + this.appService.userData.photo"
            />
            <ng-template #templateInitial>
                <div
                    class="flex-none w-8 h-8 rounded-full bg-accent flex items-center justify-center border-2 border-solid border-outline"
                >
                    <span class="uppercase font-medium text-base text-on-accent">
                        {{ appService.userData?.initials }}
                    </span>
                </div>
            </ng-template>
            <div class="user-data-div">
                <div class="user-data-div-2">
                    <div class="user-data-fi" fxLayout="row">
                        <ng-container
                            *ngIf="(this.appService.userData.firstname + this.appService.userData.lastname).length > 21"
                        >
                            <div fxFlex="0 1 calc(100% - 20px)" class="user-data-fi-text">
                                {{ this.appService.userData.firstname }}
                                <br />
                                {{ this.appService.userData.lastname }}
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="(this.appService.userData.firstname + this.appService.userData.lastname).length < 22"
                        >
                            <div fxFlex="0 1 calc(100% - 20px)" class="user-data-fi-text">
                                {{ this.appService.userData.firstname + ' ' + this.appService.userData.lastname }}
                            </div>
                        </ng-container>
                        <div class="flex-none overflow-hidden w-5 h-5 relative">
                            <i
                                class="user-data-fi-button mdi mdi-chevron-down absolute top-1"
                                [ngClass]="{ 'menu-open': menuTrigger.menuOpen }"
                            ></i>
                        </div>
                    </div>
                    <div class="user-email">
                        <app-side-menu-date-time></app-side-menu-date-time>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-panel">
            <div class="left-block">
                <fui-button
                    #matMenuTrigger="matMenuTrigger"
                    (onMenuClose)="onNotifyListClose()"
                    [matMenuTriggerFor]="notifyList"
                    [title]="iconNotifTootip"
                    [matBadge]="countStr"
                    matBadgeColor="warn"
                    textColor="white"
                    color="flat"
                    height="slim"
                    icon="bell"
                    type="button-icon"
                >
                </fui-button>
            </div>
            <div class="right-block">
                <fui-button
                    (clickEvent)="fixedMenu(!appService.settings?.is_fixed_sidenav)"
                    [title]="
                        service.language_dictionary[
                            appService.settings?.is_fixed_sidenav ? 'menu_fixed_off' : 'menu_fixed'
                        ]
                    "
                    [icon]="appService.settings?.is_fixed_sidenav ? 'pin-off-outline' : 'pin-outline'"
                    textColor="white"
                    color="flat"
                    height="slim"
                    type="button-icon"
                >
                </fui-button>
            </div>
        </div>
        <div class="overflow-x-hidden" customScroll overflowY="true" cdkScrollable>
            <cdk-tree
                #menuTree
                id="menuTree"
                fxLayout="column"
                cdkDropList
                cdkScrollable
                (cdkDropListDropped)="dropItem($event)"
                [dataSource]="service.menuDataSource"
                [treeControl]="service.menuTreeControl"
            >
                <cdk-tree-node
                    #treeNode
                    *cdkTreeNodeDef="let node"
                    [ngClass]="node.ngClass"
                    @blendIn
                    [class.node-active]="node.isActive"
                    [matTreeNodePadding]="node?.level"
                    [matTreeNodePaddingIndent]="16"
                    cdkDrag
                    cdkDragLockAxis="y"
                    [cdkDragData]="node"
                    [cdkDragDisabled]="isTouchDevice || (accessMenu.edit && !node.draggable)"
                    (cdkDragStarted)="dragStart()"
                    (mouseenter)="dragHover(node, $event)"
                    (mouseleave)="dragHoverEnd()"
                    (cdkDragReleased)="dragEnd()"
                    (click)="clickNode($event, node)"
                >
                    <div class="node-content">
                        <div class="node-content-icon" *ngIf="!isMenuOpen">
                            <ng-container *ngIf="node.level === 0">
                                <fui-icon [icon]="getNodeIcon(node)" [size]="1.5"></fui-icon>
                            </ng-container>
                        </div>
                        <div
                            *ngIf="isMenuOpen"
                            appShowTooltip=".menu-tree-node-label"
                            matTooltipPosition="right"
                            matTooltipClass="menu-item-tooltip"
                            [matTooltip]="!isDrag ? node.name : null"
                            class="flex-1 flex items-center justify-between w-full"
                        >
                            <div class="open-menu-content">
                                <div class="node-content-icon">
                                    <ng-container *ngIf="node.showSpinner$ | async; else commonIcon">
                                        <mat-progress-spinner [diameter]="20" color="primary" mode="indeterminate">
                                        </mat-progress-spinner>
                                    </ng-container>
                                    <ng-template #commonIcon>
                                        <ng-container *ngIf="node.level === 0">
                                            <fui-icon
                                                [icon]="getNodeIcon(node)"
                                                [size]="1.5"
                                                [class.close-icon]="node.children.length > 0"
                                            ></fui-icon>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                node?.rubricator_id &&
                                                node.level === 1 &&
                                                node.edit !== true &&
                                                node.children.length > 0
                                            "
                                        >
                                            <fui-icon
                                                icon="folder"
                                                [size]="1.5"
                                                [class.close-icon]="node.children.length > 0"
                                            ></fui-icon>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="(node.level === 0 || node.level === 1) && node.children.length > 0"
                                        >
                                            <fui-icon
                                                [icon]="
                                                    service.menuTreeControl.isExpanded(node)
                                                        ? 'chevron-down'
                                                        : 'chevron-right'
                                                "
                                                [size]="1.5"
                                                class="open-icon-hover open-icon"
                                                cdkTreeNodeToggle
                                            ></fui-icon>
                                        </ng-container>
                                    </ng-template>
                                </div>
                                <div
                                    class="menu-tree-node-label"
                                    [class.folder]="node.level === 1 && node.children.length > 0"
                                    [class.has-child]="node.children.length > 0"
                                >
                                    <span>{{ node.name }}</span>
                                </div>
                            </div>
                            <div class="node-context-menu" *ngIf="showMenuNode(node)">
                                <ng-container *ngIf="showOneButton(node); else menuTemplate">
                                    <ng-template
                                        [ngTemplateOutlet]="itemOneButton"
                                        [ngTemplateOutletContext]="{ item: node }"
                                    >
                                    </ng-template>
                                </ng-container>
                                <ng-template #menuTemplate>
                                    <fui-button
                                        (click)="$event.stopPropagation()"
                                        (onMenuOpen)="contextMenuTriggerRef = contextMenuTrigger"
                                        #contextMenuTrigger="matMenuTrigger"
                                        [title]="appService.language_dictionary.menu_sub_menu_add_options"
                                        [class.show-menu-button]="contextMenuTrigger.menuOpen"
                                        [matMenuTriggerFor]="contextTreeMenu"
                                        [matMenuTriggerData]="{ item: node, trigger: contextMenuTrigger }"
                                        type="button-icon"
                                        color="neutral"
                                        icon="dots-vertical"
                                        height="slim"
                                        class="tree-context-menu-button"
                                    >
                                    </fui-button>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </cdk-tree-node>
                <cdk-tree-node
                    #treeNode
                    *cdkTreeNodeDef="let node; when: hasChildren"
                    [ngClass]="node.ngClass"
                    @blendIn
                    [class.node-active]="node.isActive"
                    [matTreeNodePadding]="node.level"
                    [matTreeNodePaddingIndent]="16"
                    cdkDrag
                    cdkDragLockAxis="y"
                    [cdkDragData]="node"
                    [cdkDragDisabled]="isTouchDevice || (accessMenu.edit && !node.draggable)"
                    (cdkDragStarted)="dragStart()"
                    (mouseenter)="dragHover(node, $event)"
                    (mouseleave)="dragHoverEnd()"
                    (cdkDragReleased)="dragEnd()"
                    (click)="clickNode($event, node)"
                >
                    <div class="node-content">
                        <div class="node-content-icon" *ngIf="!isMenuOpen">
                            <ng-container *ngIf="node.level === 0">
                                <fui-icon [icon]="getNodeIcon(node)" [size]="1.5"></fui-icon>
                            </ng-container>
                        </div>
                        <div
                            *ngIf="isMenuOpen"
                            appShowTooltip=".menu-tree-node-label"
                            matTooltipPosition="right"
                            matTooltipClass="menu-item-tooltip"
                            [matTooltip]="!isDrag ? node.name : null"
                            class="flex-1 flex items-center justify-between w-full"
                        >
                            <div class="open-menu-content">
                                <div class="node-content-icon">
                                    <ng-container *ngIf="node.showSpinner$ | async; else commonIcon">
                                        <mat-progress-spinner [diameter]="20" color="primary" mode="indeterminate">
                                        </mat-progress-spinner>
                                    </ng-container>
                                    <ng-template #commonIcon>
                                        <ng-container *ngIf="node.level === 0">
                                            <fui-icon
                                                [icon]="getNodeIcon(node)"
                                                [size]="1.5"
                                                [class.close-icon]="node.children.length > 0"
                                            ></fui-icon>
                                        </ng-container>
                                        <ng-container *ngIf="node.level === 1 && node.children.length > 0">
                                            <fui-icon
                                                [icon]="
                                                    service.menuTreeControl.isExpanded(node) ? 'folder-open' : 'folder'
                                                "
                                                [size]="1.5"
                                                [class.close-icon]="node.children.length > 0"
                                            ></fui-icon>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="(node.level === 0 || node.level === 1) && node.children.length > 0"
                                        >
                                            <fui-icon
                                                cdkTreeNodeToggle
                                                [icon]="
                                                    service.menuTreeControl.isExpanded(node)
                                                        ? 'chevron-down'
                                                        : 'chevron-right'
                                                "
                                                [size]="1.5"
                                                class="open-icon-hover open-icon"
                                            ></fui-icon>
                                        </ng-container>
                                    </ng-template>
                                </div>
                                <div
                                    class="menu-tree-node-label"
                                    [class.folder]="node.level === 1 && node.children.length > 0"
                                    [class.has-child]="node.children.length > 0"
                                >
                                    <span>{{ node.name }}</span>
                                </div>
                            </div>
                            <div class="node-context-menu" *ngIf="showMenuNode(node)">
                                <ng-container *ngIf="showOneButton(node); else menuTemplate">
                                    <ng-template
                                        [ngTemplateOutlet]="itemOneButton"
                                        [ngTemplateOutletContext]="{ item: node }"
                                    >
                                    </ng-template>
                                </ng-container>
                                <ng-template #menuTemplate>
                                    <fui-button
                                        #contextMenuTrigger="matMenuTrigger"
                                        (click)="$event.stopPropagation()"
                                        (onMenuOpen)="contextMenuTriggerRef = contextMenuTrigger"
                                        [title]="appService.language_dictionary.menu_sub_menu_add_options"
                                        [class.show-menu-button]="contextMenuTrigger.menuOpen"
                                        [matMenuTriggerFor]="contextTreeMenu"
                                        [matMenuTriggerData]="{ item: node, trigger: contextMenuTrigger }"
                                        type="button-icon"
                                        color="neutral"
                                        icon="dots-vertical"
                                        height="slim"
                                        class="tree-context-menu-button"
                                    >
                                    </fui-button>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </cdk-tree-node>
            </cdk-tree>
            <!-- Кнопка добавить пункт меню -->
            <ng-container *ngIf="accessMenu.add || accessPages.add">
                <div class="add-block">
                    <button
                        mat-button
                        class="add-button"
                        [matMenuTriggerFor]="createNewMenuItem"
                        [matMenuTriggerData]="{
                            item: { id: 1 },
                            level: 0,
                        }"
                    >
                        <i class="mdi mdi-plus"></i>
                        <span class="add-button-text" [@popUpName]="labelSate">
                            {{ appService.language_dictionary.menu_add_chapter }}
                        </span>
                    </button>
                </div>
            </ng-container>
            <mat-divider class="footer-divider"></mat-divider>
            <div>
                <div fxLayout="column" fxLayoutGap="25px" fxLayoutAlign="flex-start" class="footer-info">
                    <div class="block-1">&copy; {{ appService?.settings?.footer_copyright?.value }}</div>
                    <div class="block-2">
                        <strong>{{ appService.language_dictionary.support_service }}</strong>
                        <br />
                        {{ appService.language_dictionary.system_phone }}:
                        <a class="footer_link" [href]="'tel:' + appService?.settings?.contacts?.value?.support_phone">
                            {{ appService?.settings?.contacts?.value?.support_phone }}</a
                        >&nbsp;
                        <br />
                        <div style="display: inline-block">
                            e-mail:
                            <a
                                class="footer_link"
                                [href]="'mailto:' + appService?.settings?.contacts?.value?.support_email"
                            >
                                {{ appService?.settings?.contacts?.value?.support_email }}
                            </a>
                        </div>
                    </div>
                    <div class="block-3">
                        <div *ngIf="appService.settings.version_platform">
                            {{ appService.language_dictionary.version_platform }}
                            {{ appService.settings.version_platform }}
                        </div>
                        <div *ngIf="appService.settings.lastUpdate">
                            {{ appService.language_dictionary.lastUpdate }}
                            {{ appService.settings.lastUpdate }}
                        </div>
                        <div *ngIf="appService.settings.database">
                            {{ appService.language_dictionary.database }}
                            {{ appService.settings.database }}
                        </div>
                        <div>fui-components {{ fuiComponentsVersion }}</div>
                        <br />
                        <div>
                            {{ appService.language_dictionary.system_footer_copyright }}
                            <a
                                href="http://ifrigate.ru"
                                target="_blank"
                                class="footer_link"
                                [innerHTML]="appService.language_dictionary.system_footer_company"
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Меню доп. опций -->
<mat-menu #contextTreeMenu="matMenu">
    <ng-template matMenuContent let-item="item">
        <div [class.!hidden]="menuPortal">
            <button
                *ngIf="showMenuEdit(item)"
                (click)="openEdit(item.id, item.parent_id, item?.type ?? '', item?.level)"
                mat-menu-item
                class="context-menu-item"
            >
                {{ appService.language_dictionary.system_edit }}
            </button>

            <button
                *ngIf="showMenuAdd(item)"
                mat-menu-item
                class="context-menu-item"
                [matMenuTriggerFor]="createNewMenuItem"
                [matMenuTriggerData]="{
                    item: item,
                    level: item.level ? item.level + 1 : 1,
                }"
            >
                {{ appService.language_dictionary.menu_add_chapter }}
            </button>

            <button
                *ngIf="showMenuDelete(item)"
                (click)="$event.stopPropagation(); initMenuPortal(deleteItemPopup)"
                mat-menu-item
                class="context-menu-item delete"
            >
                {{ appService.language_dictionary.system_del }}
            </button>
        </div>
    </ng-template>

    <ng-template [cdkPortalOutlet]="menuPortal"> </ng-template>
</mat-menu>

<!-- Подменю добавление нового пункта меню -->
<mat-menu #createNewMenuItem="matMenu" xPosition="before">
    <ng-template matMenuContent let-item="item" let-level="level">
        <ng-container *ngIf="accessMenu.add">
            <ng-container *ngIf="level < 2">
                <button (click)="this.openEdit(0, item.id, 'folder', level)" class="context-menu-item" mat-menu-item>
                    <span>{{ appService.language_dictionary.menu_folder }}</span>
                </button>
            </ng-container>
            <button (click)="this.openEdit(0, item.id, 'url', level)" mat-menu-item class="context-menu-item">
                <span> {{ appService.language_dictionary.menu_url }}</span>
            </button>
            <button (click)="this.openEdit(0, item.id, 'registry', level)" mat-menu-item class="context-menu-item">
                <span> {{ appService.language_dictionary.menu_registry }}</span>
            </button>
            <button (click)="this.openEdit(0, item.id, 'controller', level)" mat-menu-item class="context-menu-item">
                <span>{{ appService.language_dictionary.menu_controller }}</span>
            </button>
        </ng-container>
        <ng-container *ngIf="accessPages.add">
            <button (click)="this.openEdit(0, item.id, 'page', level)" mat-menu-item class="context-menu-item">
                <span>{{ appService.language_dictionary.menu_text_page }}</span>
            </button>
        </ng-container>
    </ng-template>
</mat-menu>

<!-- Меню пользователя -->
<mat-menu #menuUser="matMenu" classList="sideMenu-user-menu ml-11">
    <ng-container *ngIf="canViewProfile">
        <button (click)="openEditSelf()" class="context-menu-item" mat-menu-item>
            <span>{{ appService.language_dictionary.user_profile }}</span>
        </button>
    </ng-container>
    <ng-container
        *ngIf="
            (appService.appSettings?.guides.videoInstructions | keyvalue).length > 0 ||
            (appService.appSettings?.guides.userGuides | keyvalue).length > 0
        "
    >
        <button [matMenuTriggerFor]="helpMenu" mat-menu-item class="context-menu-item">
            <span>{{ appService.language_dictionary.system_help }}</span>
        </button>
    </ng-container>

    <button (click)="signOut()" mat-menu-item class="context-menu-item">
        <span>{{ appService.language_dictionary.system_exit }}</span>
    </button>
</mat-menu>

<mat-menu #helpMenu="matMenu">
    <button
        *ngIf="(appService.appSettings?.guides.userGuides | keyvalue).length"
        [matMenuTriggerFor]="helpUserguides"
        mat-menu-item
        class="context-menu-item"
    >
        <span>{{ appService.language_dictionary.help_manuals }}</span>
    </button>
    <button
        *ngIf="(appService.appSettings?.guides.videoInstructions | keyvalue).length"
        [matMenuTriggerFor]="helpVideoinstructions"
        mat-menu-item
        class="context-menu-item"
    >
        <span>{{ appService.language_dictionary.help_video_instructions }}</span>
    </button>
</mat-menu>

<mat-menu #helpUserguides="matMenu">
    <ng-container *ngFor="let item of appService.appSettings?.guides.userGuides | keyvalue">
        <button (click)="openGuide(item.value?.url)" mat-menu-item class="context-menu-item">
            <span>{{ item.value?.name }}</span>
        </button>
    </ng-container>
</mat-menu>

<mat-menu #helpVideoinstructions="matMenu">
    <ng-container *ngFor="let item of appService.appSettings?.guides.videoInstructions | keyvalue">
        <button (click)="openVideoGuide(item.value?.url)" class="context-menu-item" mat-menu-item>
            <span>{{ item.value?.name }}</span>
        </button>
    </ng-container>
</mat-menu>
<ng-template #itemOneButton let-item="item">
    <ng-container *ngIf="showMenuEdit(item)">
        <fui-button
            (clickEvent)="openEdit(item.id, item.parent_id, item?.type, item?.level)"
            (click)="$event.stopPropagation()"
            [title]="appService.language_dictionary.system_edit"
            type="button-icon"
            color="neutral"
            icon="pencil"
            height="slim"
            class="tree-context-menu-button"
        >
        </fui-button>
    </ng-container>
    <ng-container *ngIf="showMenuAdd(item)">
        <fui-button
            #contextMenuAddTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="createNewMenuItem"
            [matMenuTriggerData]="{ item, level: item.level ? item.level + 1 : 1 }"
            [title]="appService.language_dictionary.menu_add_chapter"
            [class.show-menu-button]="contextMenuAddTrigger?.menuOpen"
            type="button-icon"
            color="neutral"
            icon="plus"
            height="slim"
            class="tree-context-menu-button"
        >
        </fui-button>
    </ng-container>
    <ng-container *ngIf="showMenuDelete(item)">
        <fui-button
            (clickEvent)="deleteWithConfirm(item)"
            (click)="$event.stopPropagation()"
            [title]="appService.language_dictionary.system_del"
            type="button-icon"
            color="neutral"
            icon="delete"
            height="slim"
            class="tree-context-menu-button"
        >
        </fui-button>
    </ng-container>
</ng-template>
<mat-menu #notifyList="matMenu" backdropClass="menuPopUp" classList="menuPopUp">
    <ng-container *ngIf="matMenuTrigger.menuOpen">
        <notify-list (click)="$event.stopPropagation()" (close)="matMenuTrigger.closeMenu()"> </notify-list>
    </ng-container>
</mat-menu>

<ng-template #deleteItemPopup>
    <div (click)="$event.stopPropagation()" class="menu-confirm">
        <div class="menu-confirm-header">
            <fui-button
                (clickEvent)="closeConfirmDeletePortal()"
                [title]="appService.language_dictionary.system_annulment"
                [iconSize]="1"
                type="button-icon"
                icon="chevron-left"
                height="slim"
                color="flat"
                borderRadius="circle"
            >
            </fui-button>
            <span class="menu-confirm-message">{{ appService.language_dictionary?.menu_confirm_title_delete }}</span>
            <fui-button
                (clickEvent)="closeConfirmBlock()"
                [title]="appService.language_dictionary.system_close"
                [iconSize]="1"
                type="button-icon"
                icon="close"
                height="slim"
                color="flat"
                borderRadius="circle"
            >
            </fui-button>
        </div>
        <div>
            {{ appService.language_dictionary?.menu_confirm_message_delete }}
        </div>
        <div class="action">
            <fui-button (clickEvent)="confirmDel()" [label]="appService.language_dictionary?.system_del" height="mini">
            </fui-button>
        </div>
    </div>
</ng-template>
